import { Injectable } from '@angular/core';
import currentBuildNumber from '@root/build_number';
import { AlertsService } from './alerts/alerts.service';

@Injectable({
  providedIn: 'root'
})
export class VersionCheckerService {
  constructor(private alertsService: AlertsService) {
    setTimeout(() => this.checkBuildNumber(), 5000);
    // Check every hour
    setInterval(() => this.checkBuildNumber(), 60 * 60_000);
  }

  private async checkBuildNumber() {
    const response = await fetch('/assets/build_number.json', {
      cache: 'no-store'
    });
    if (response.ok) {
      const buildNumber = await response.json();
      if (buildNumber !== currentBuildNumber) {
        this.alertsService.addAlert({
          title: 'New version available',
          message: `Please reload the page for the best experience.`,
          type: 'warning',
          config: {
            disableTimeOut: true,
            closeButton: true
          }
        });
      }
    }
  }
}
